import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SqlEditorPopupComponent } from "../../attribute-mapping-config/sql-editor-popup/sql-editor-popup.component";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { ReportlinksserviceService } from "../../reportlinks/reportlinksservice.service";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";

@Component({
    selector: "app-create-formula-pop-up",
    templateUrl: "./create-formula-pop-up.component.html",
    styleUrls: ["./create-formula-pop-up.component.scss"],
    standalone: false
})
export class CreateFormulaPopUpComponent implements OnInit {
  @ViewChild("expressionTextarea")
  expressionTextarea!: ElementRef<HTMLTextAreaElement>;

  formulaForm!: FormGroup;
  sqlExpression: any;

  mode: "Analytic" | "Statistical" = "Analytic";

  operators = ["+", "-", "*", "/", "(", ")"];
  functions = [
    // BASIC
    { name: "log", display: "log( )", value: "Math.log(" },
    { name: "log10", display: "log10( )", value: "Math.log10(" },
    { name: "log2", display: "log2( )", value: "Math.log2(" },

    { name: "sqrt", display: "√( )", value: "Math.sqrt(" },
    { name: "exp", display: "exp( )", value: "Math.exp(" },

    { name: "abs", display: "abs( )", value: "Math.abs(" },
    { name: "round", display: "round( )", value: "Math.round(" },
    { name: "ceil", display: "ceil( )", value: "Math.ceil(" },
    { name: "floor", display: "floor( )", value: "Math.floor(" },

    // TRIG
    { name: "sin", display: "sin( )", value: "Math.sin(" },
    { name: "cos", display: "cos( )", value: "Math.cos(" },
    { name: "tan", display: "tan( )", value: "Math.tan(" },

    // POWER
    { name: "pow", display: "pow( )", value: "Math.pow(" },

    // STAT FUNCTIONS (important)
    { name: "min", display: "min( )", value: "Math.min(" },
    { name: "max", display: "max( )", value: "Math.max(" },
  ];

  formulaExamples = [
    { name: "Proportion", formula: "(A / (A + B))" },
    { name: "Percentage", formula: "(A / B) * 100" },
    { name: "Odds Ratio", formula: "(A / B) / (C / D)" },
    { name: "Risk Ratio", formula: "(A / (A + B)) / (C / (C + D))" },
    { name: "Z-Score", formula: "(X - μ) / σ" },
    { name: "Log Transformation", formula: "log(A + B)" },
  ];

  variables = [];

  isValid = true;
  validationMessage = "";
  testResult: number | null = null;
  testValues: any = {};

  buttonColor = "";
  titleText = "Create Formula";
  selectedVariable: any;
  datasets: never[];
  selectedDataset: null;
  getdata: any;
  UserRolesWithRoleId: any;
  isEditMode = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<CreateFormulaPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private jsignalsService: JsignalService,
    private linkservice: ReportlinksserviceService,
    private service: ReportingServiceService,
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private spinner: NgxUiLoaderService,
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.Useroles();
    this.loadAllDatasets();
    console.log("Data Recevied", this.data);
    this.variables = this.data?.variables;
    console.log("Received variables from parent:", this.variables);

    // EDIT MODE
    if (this.data?.formula) {
       this.isEditMode = true;
      console.log("Edit Formula Data : ", this.data.formula);
      const f = this.data.formula;
      this.titleText = "Update Formula";

      this.patchFormData(f);
    }
  }

  initializeForm() {
    this.formulaForm = this.fb.group({
      name: ["", Validators.required],
      description: ["", Validators.required],
      expression: [""],
      sqlExpression: [""],
      mode: ["Analytic"],
    });
  }

  // MODE CHANGE
  onModeChange(mode: any) {
    this.formulaForm.reset();
    this.mode = mode;
    this.formulaForm.patchValue({ mode });
    

    if (mode === "Analytic") {
      // clear Statistical expression
      this.formulaForm.patchValue({ expression: "" });
    } else {
      // clear SQL expression
      this.formulaForm.patchValue({ sqlExpression: "" });
      this.resetStatisticalMode();
    }
    
  }

  resetStatisticalMode() {
    this.testResult = null;
    this.testValues = {};
    this.validationMessage = "";
    this.isValid = true;
    this.selectedVariable = null;
    this.clearDropdown();
  }

  errorStateMatcher = {
    isErrorState: (control: any) => {
      return !!(control && control.invalid && control.touched);
    },
  };

  // SQL BUILDER
  openSqlEditor() {
    if (!this.datasets || this.datasets.length === 0) {
      this.snackBar.open("No datasets available.", "Close", { duration: 3000 });
      return;
    }

    const datasetList = this.datasets.map((item: any) => {
      let columns = [];

      try {
        columns = JSON.parse(item.columns || "[]");
      } catch (e) {
        columns = [];
      }

      return {
        objectName: item.datasetname,
        objectId: item.reportcreationid,
        columns: columns,
      };
    });

    const dialogRef = this.dialog.open(SqlEditorPopupComponent, {
      width: "90%",
      autoFocus: false,
      maxWidth: "100vw",
      height: "95%",
      disableClose: true,
      data: { objectList: datasetList, fromJSIPFormulaBuilder: true ,Query:this.sqlExpression },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.sqlExpression = result;
        this.formulaForm.patchValue({ sqlExpression: result });
      }
    });
  }

  onVariableSelect(value: string) {
    console.log("value",value)
    if (!value) return;

    this.insert(value);

    //FORCE CLEAR (after PrimeNG finishes its update cycle)
    setTimeout(() => {
      this.selectedVariable = null;
    }, 0);
  }

  // ENHANCED INSERT WITH CURSOR POSITION
  insert(value: string) {
    const textarea = this.expressionTextarea?.nativeElement;
    const currentExpr = this.formulaForm.get("expression")?.value || "";

    if (!textarea) {
      // Fallback: append at end
      this.formulaForm.patchValue({
        expression: currentExpr + value,
      });
      this.clearDropdown();
      return;
    }

    // Get cursor position
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    // Insert at cursor position
    const newExpr =
      currentExpr.substring(0, start) + value + currentExpr.substring(end);
    this.formulaForm.patchValue({ expression: newExpr });

    // Set cursor position after inserted text
    setTimeout(() => {
      textarea.focus();
      const newCursorPos = start + value.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  }

  // INSERT FUNCTION
  insertFunction(fn: any) {
    this.insert(fn.value);
  }

  clearDropdown() {
    setTimeout(() => {
      this.selectedVariable = null;
    }, 0);
  }

  // CLEAR FORMULA
  clearFormula() {
    this.formulaForm.patchValue({ expression: "" });
    this.testResult = null;
    this.testValues = {};
    this.validationMessage = "";
    this.isValid = true;
    this.clearDropdown();
  }

  // USE EXAMPLE
  // Replace the existing useExample method with this
  useExample(example: any) {
    if (example && example.formula) {
      this.formulaForm.patchValue({ expression: example.formula });
      this.testFormula();
    }
  }

  // WRAP WITH PARENTHESES
  wrapWithParentheses() {
    const textarea = this.expressionTextarea?.nativeElement;
    const currentExpr = this.formulaForm.get("expression")?.value || "";

    if (!textarea) {
      const wrapped = `(${currentExpr})`;
      this.formulaForm.patchValue({ expression: wrapped });

      return;
    }

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = currentExpr.substring(start, end);

    let newExpr: string;
    let newCursorStart: number;
    let newCursorEnd: number;

    if (selectedText) {
      // Wrap selected text
      newExpr =
        currentExpr.substring(0, start) +
        "(" +
        selectedText +
        ")" +
        currentExpr.substring(end);
      newCursorStart = start + 1;
      newCursorEnd = end + 1;
    } else {
      // Wrap entire expression
      newExpr = `(${currentExpr})`;
      newCursorStart = 1;
      newCursorEnd = currentExpr.length + 1;
    }

    this.formulaForm.patchValue({ expression: newExpr });

    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(newCursorStart, newCursorEnd);
    }, 0);
  }

  // TEST FORMULA (ENHANCED)
  testFormula() {
    const expr = this.formulaForm.get("expression")?.value;

    if (!expr || expr.trim() === "") {
      this.validationMessage = "Please enter an expression";
      this.isValid = false;
      this.testResult = null;
      this.testValues = {};
      return;
    }

    let testExpr = expr;
    const values: any = {};

    // Generate random test values for variables
    this.variables.forEach((v) => {
      if (expr.includes(v.formulaName)) {
        values[v.formulaName] = Math.floor(Math.random() * 50 + 1);
      }
    });

    try {
      // Replace variables with values
      let processedExpr = testExpr;
      Object.keys(values).forEach((k) => {
        const regex = new RegExp(`\\b${k}\\b`, "g");
        processedExpr = processedExpr.replace(regex, values[k].toString());
      });

      // Check for invalid patterns
      if (/([+\-*/^])\1/.test(processedExpr)) {
        throw new Error("Consecutive operators detected");
      }

      if (/\(\s*[+\-*/]/.test(processedExpr)) {
        throw new Error("Invalid operator after parenthesis");
      }

      // Evaluate expression
      const result = Function(`"use strict"; return (${processedExpr})`)();

      if (!isFinite(result)) {
        throw new Error("Result is not finite (division by zero or overflow)");
      }

      this.testResult = result;
      this.testValues = values;
      this.validationMessage = "Formula is valid";
      this.isValid = true;
    } catch (e: any) {
      this.validationMessage = `Invalid: ${e.message || "Syntax error"}`;
      this.isValid = false;
      this.testResult = null;
      this.testValues = {};
    }
  }

  // SHOW SNACKBAR HELPER
  showSnackBar(message: string, type: "success" | "error" | "info" = "info") {
    const panelClass = `snackbar-${type}`;
    this.snackBar.open(message, "Close", {
      duration: 3000,
      horizontalPosition: "end",
      verticalPosition: "top",
      panelClass: [panelClass],
    });
  }

  saveFormula() {
    if (this.formulaForm.invalid) {
      this.formulaForm.markAllAsTouched();
      return;
    }

    let finalExpression = "";

    if (this.mode === "Analytic") {
      finalExpression = this.formulaForm.value.sqlExpression;
    } else {
      finalExpression = this.formulaForm.value.expression;
    }

    if (!finalExpression || finalExpression.trim() === "") {
      this.snackBar.open("Expression is required", "Close", { duration: 2000 });
      return;
    }

    const DnsName = this.localStorage.getSettings("dnsName");
    const Workspaceid = this.localStorage.getSettings("WorkspaceId");

    const payload = {
      formulaName: this.formulaForm.value.name,
      formulaDesc: this.formulaForm.value.description,
      formulaType: this.mode,
      expression: finalExpression,
      variables:
        this.mode === "Statistical"
          ? this.getUsedVariables(finalExpression)
          : [],
      dnsid: DnsName,
      workspaceid: Workspaceid,
    };

    console.log("Saving formula with payload:", payload);
    this.sqlExpression = null;

    this.dialogRef.close(payload);
  }

  // Add these helper methods to your component class
  hasTestValues(): boolean {
    return this.testValues && Object.keys(this.testValues).length > 0;
  }

  getTestValuesDisplay(): string {
    if (!this.testValues) return "";
    return Object.entries(this.testValues)
      .map(([key, value]) => `${key}=${value}`)
      .join(", ");
  }

  getUsedVariables(expression: string): any[] {
    console.log("Extracting variables from expression:", expression);
    if (!expression) return [];

    return this.variables.filter((v) => {
      const regex = new RegExp(`\\b${v.formulaName}\\b`);
      return regex.test(expression);
    });
  }

  Useroles(): void {
    const dnsid = this.localStorage.getSettings("dnsName");
    if (dnsid) {
      this.service.getUserRoles(dnsid).subscribe(
        (response) => {
          this.UserRolesWithRoleId = response; // Assign fetched user roles to the types array
          console.log(this.UserRolesWithRoleId);
        },
        (error) => {
          console.error("Error fetching user roles:", error);
        },
      );
    }
  }

  loadAllDatasets() {
    this.linkservice
      .retrievereport(
        this.localStorage.getSettings("UserId"),
        this.localStorage.getSettings("dnsName"),
        this.localStorage.getSettings("AuthUsername"),
      )
      .subscribe((response) => {
        this.spinner.start();
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.snackBar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          // this.rowbindingdata.setGridOption('rowData', []);
          this.datasets = [];
          this.selectedDataset = null;
        } else {
          // below code added for dispaly associated roles of Dataset in the Grid
          console.log(response);
          this.getdata = response;
          console.log(this.getdata);
          for (let i = 0; i < this.getdata.length; i++) {
            let stringValues = "";
            if (this.getdata[i].dataset_rolesIds) {
              let subString = this.getdata[i].dataset_rolesIds.split(",");
              console.log(subString);
              for (let j = 0; j < subString.length; j++) {
                console.log(this.UserRolesWithRoleId);
                for (let k = 0; k < this.UserRolesWithRoleId.length; k++) {
                  console.log(this.UserRolesWithRoleId[k][0]);
                  if (this.UserRolesWithRoleId[k][0] == subString[j]) {
                    if (stringValues.length == 0) {
                      stringValues = this.UserRolesWithRoleId[k][1];
                      break;
                    } else {
                      stringValues =
                        stringValues + "," + this.UserRolesWithRoleId[k][1];
                      break;
                    }
                  }
                }
              }
              this.getdata[i]["dataset_rolesIdStrings"] = stringValues;
            }
          }
          console.log(this.getdata);
          // Filter active datasets only (status === 'Yes') && Completed Data Set
          this.datasets = this.getdata.filter(
            (ds: any) =>
              ds.status === "Yes" && ds.generationStatus === "Completed",
          );
        }
        this.spinner.stop();
      });
  }

  patchFormData(formData: any) {
    this.mode = formData.formulaType || "Analytic";
    if (formData.formulaType === "Analytic") {
      this.formulaForm.patchValue({ sqlExpression: formData.expression });
      this.sqlExpression = formData.expression;
      console.log("Patched SQL Expression:", this.sqlExpression);
    } else {
      this.formulaForm.patchValue({ expression: formData.expression });
    }
    this.formulaForm.patchValue({
      name: formData.formulaName || "",
      description: formData.formulaDesc || "",
      mode: this.mode
    });
  }

  close() {
    this.sqlExpression = null;
    this.dialogRef.close();
  }
}
